import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSlash, FiUserX, FiUnlock, FiSearch, FiUsers } = FiIcons;

export default function UserModeration({ users, restrictions, onModerate, onRestore }) {
  const [searchTerm, setSearchTerm] = useState('');

  // Filtrar participantes según búsqueda
  const filteredUsers = users.filter(user =>
    user.nickname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className="flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#111] h-[550px]">
      <div className="border-b border-white/10 px-4 py-4 sm:px-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3 shrink-0">
        <div>
          <h2 className="font-semibold text-white text-sm sm:text-base flex items-center gap-2">
            <SafeIcon icon={FiUsers} className="text-red-500" />
            Participantes Activos
          </h2>
          <p className="mt-0.5 text-xs text-gray-500">
            Expulsa temporalmente o bloquea permanentemente a los usuarios.
          </p>
        </div>
      </div>
      {/* Caja de Búsqueda */}
      <div className="px-4 py-2 bg-black/30 border-b border-white/5 shrink-0">
        <div className="flex items-center gap-2 rounded-lg bg-white/5 px-2.5 py-1.5">
          <SafeIcon icon={FiSearch} size={14} className="text-gray-500" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Buscar participante por apodo..."
            className="w-full bg-transparent text-xs text-white outline-none placeholder:text-gray-600"
          />
        </div>
      </div>
      {/* Lista con scroll elegante y visible */}
      <div className="flex-1 divide-y divide-white/5 overflow-y-auto">
        {filteredUsers.map((user) => {
          const restriction = restrictions.find((item) => (
            item.active && (
              item.subject_client_id === user.sender_id ||
              item.subject_nickname.toLowerCase() === user.nickname.toLowerCase()
            )
          ));

          const isAnnouncementSender = user.nickname === '📢 ANUNCIO OFICIAL';
          if (isAnnouncementSender) return null; // Omitir el bot de anuncios

          return (
            <div
              key={`${user.nickname}-${user.sender_id}`}
              className="flex items-center justify-between gap-3 p-4 hover:bg-white/[0.01] transition-colors"
            >
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-600/10 text-sm font-bold text-red-500">
                  {user.nickname.slice(0, 1).toUpperCase()}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-white">
                    {user.nickname}
                  </p>
                  <p className="text-[10px] text-gray-500">
                    {user.messageCount} {user.messageCount === 1 ? 'mensaje' : 'mensajes'}
                  </p>
                </div>
              </div>
              {restriction ? (
                <button
                  type="button"
                  onClick={() => onRestore(restriction)}
                  className="flex items-center gap-1.5 rounded-lg bg-green-500/10 px-2.5 py-1.5 text-[11px] font-medium text-green-400 hover:bg-green-500/20 transition-all shrink-0"
                >
                  <SafeIcon icon={FiUnlock} size={12} />
                  Habilitar
                </button>
              ) : (
                <div className="flex gap-1.5 shrink-0">
                  <button
                    type="button"
                    onClick={() => onModerate(user, 'expel')}
                    className="flex items-center gap-1.5 rounded-lg bg-amber-500/10 px-2.5 py-1.5 text-[11px] font-medium text-amber-400 hover:bg-amber-500/20 transition-all"
                    title="Expulsar por 15 minutos"
                  >
                    <SafeIcon icon={FiUserX} size={12} />
                    Expulsar
                  </button>
                  <button
                    type="button"
                    onClick={() => onModerate(user, 'ban')}
                    className="flex items-center gap-1.5 rounded-lg bg-red-500/10 px-2.5 py-1.5 text-[11px] font-medium text-red-400 hover:bg-red-500/20 transition-all"
                    title="Bloquear permanentemente"
                  >
                    <SafeIcon icon={FiSlash} size={12} />
                    Bloquear
                  </button>
                </div>
              )}
            </div>
          );
        })}
        {filteredUsers.length === 0 && (
          <div className="p-8 text-center text-sm text-gray-600">
            No se encontraron participantes.
          </div>
        )}
      </div>
    </section>
  );
}